import { Component, Input, Output, EventEmitter } from '@angular/core';

import { PessoaContatoTipo, outrosContatosTipos, PessoaContatoTipoSortPipe } from '../tipo';

@Component({
    selector: 'sgt-pessoa-contato-dropdown-insert',
    templateUrl: './pessoa-contato-dropdown-insert.component.html',
    styleUrls: ['./pessoa-contato-dropdown-insert.component.less'],
    providers: [
        PessoaContatoTipoSortPipe
    ]
})
export class PessoaContatoDropdownInsertComponent {
    @Input() dropup: boolean;
    @Input() classBtn = 'btn-link btn-link-primary'
    @Output() insert = new EventEmitter<PessoaContatoTipo>();
    tiposContatos: PessoaContatoTipo[];

    constructor(private pessoaContatoTipoSortPipe: PessoaContatoTipoSortPipe) { }

    ngOnInit(): void {
        this.tiposContatos = this.pessoaContatoTipoSortPipe.transform(outrosContatosTipos);
    }
}
